export const firebaseConfig = {
  apiKey: "AIzaSyBUtbvkqHIsCVooZC_CjXD1Uwa8Uy01_hY",
  authDomain: "tracking-164e6.firebaseapp.com",
  projectId: "tracking-164e6",
  storageBucket: "tracking-164e6.firebasestorage.app",
  messagingSenderId: "601299656004",
  appId: "1:601299656004:web:1ede44a18f8e32967b4b11",
  measurementId: "G-JPXR99NTP4",
};
